import { useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../store/storeTypes';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
